<template>
  <div id="detailePage" class="modal" :style="{ display: (openDialog ? 'block' : 'none') }">
    <header>
        <div class="detailePageTitle" >
            <h1>{{this.specialExhibitionWork && this.specialExhibitionWork.title}}</h1>
            <h2>{{this.specialExhibition && this.specialExhibition.name}} {{this.specialExhibitionWork && this.specialExhibitionWork.photographer}}</h2>
        </div>
        <div class="detailePageMenu" >
          <ShareButton ulClassName="detailePageSnsShareBtn" message="この作品ページをシェア" />
          <div class="detailePageClose">
              <a href="javascript:void(0);" @click="close"><img class="mark10sen" src="/img/close.png" srcset="/img/close@2x.png 2x" alt=""/></a>
          </div>
        </div>
    </header>

    <div id="mainDetailePage">
      <div class="inner3" style="position: relative;">
          <div class="photoArea" :class="{ adjustPositionPhotoArea: isImageOnly() }">
              <div class="photoImage" :style="{width: frameWidth + 'px', height: frameHeight + 'px'}" @mouseout="mouseoutImageHandler" @click="clickImageHandler" @touchend="touchImageHandler">
                <img src="" class="image" @load="loadComplete" ref="imageData">
              </div>
              <div class="photoImageMenuArea" style="{width: 100%}" v-show="isLoaded">
                  <ul class="photoImageMenu">
                      <li class="resetBtn"><a href="javascript:void(0);" @click="reset">リセット</a></li>
                      <li class="zoomBtn" :class="{ nactive: isZoomMax }"><a href="javascript:void(0);" @click="zoomIn">拡&nbsp;大&nbsp;</a></li>
                      <li class="zoomoutBtn" :class="{ nactive: isZoomMin }"><a href="javascript:void(0);" @click="zoomOut">縮&nbsp;小&nbsp;</a></li>
                  </ul>
              </div>
          </div><!-- /photoArea-->
          <div v-if="!isLoaded" class="loadingBox">
            <img src="/img/loading.svg" style="width: 96px; height: 96px; display: block; filter: blur(0px);" />
          </div>
          <div class="photoInfo" :class="{ adjustPositionPhotoInfo: isImageOnly() }">
            <div v-if="isCommentaryExists()" class="exhCommentary">
              <div class="exhCommentaryHead">
                <h3>作品解説</h3>
                <a v-if="isCommentExists() && isCommentTabOn()" :class="{ location: currentCommentaryType === 'comment' }" href="javascript:void(0);" @click="changeComentaryTab('comment')">テキスト</a>
                <a v-if="isVoiceExists()" :class="{ location: currentCommentaryType === 'voice' }" href="javascript:void(0);" @click="changeComentaryTab('voice')">音声</a>
                <a v-if="isMovieExists()" :class="{ location: currentCommentaryType === 'movie' }" href="javascript:void(0);" @click="changeComentaryTab('movie')">動画</a>
              </div>
              <div class="exhCommentaryBody">
                <div v-if="isCommentExists() && currentCommentaryType === 'comment'" class="exhCommentaryTxt">
                  <p><span v-html="specialExhibitionWork && specialExhibitionWork.comment"></span></p>
                </div>
                <div v-if="isVoiceExists() && currentCommentaryType === 'voice'" class="exhCommentaryTxt">
                  <audio
                      v-if="specialExhibitionWork && specialExhibitionWork.voice"
                      class="my-1"
                      controls
                      :src="specialExhibitionWork.voice">
                          音声再生がサポートされていないブラウザです。
                  </audio>
                </div>
                <div v-if="isMovieExists() && currentCommentaryType === 'movie'" class="exhCommentaryMovie">
                  <iframe width="320" height="180" :src="convertYoutubeUrl(specialExhibitionWork.youtubeUrl)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
            </div><!-- /exhCommentary-->
          </div><!-- /photoInfo-->
      </div><!-- /inner-->
    </div><!-- /mainDetailePage-->
    <footer>
      <div class="inner3" v-show="isLoaded">
        <div class="copyright">
          Copyright &copy; Tokyo Camera Club Corp. All Rights Reserved.
        </div><!-- #copyright -->
      </div>
    </footer>
  </div>
</template>

<script>
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import YoutubeUtil from '@/util/YoutubeUtil'
import Viewer from 'viewerjs'
import ShareButton from '@/components/modules/ShareButton'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    ShareButton
  },
  props: [
    'isOpen',
    'specialExhibition',
    'specialExhibitionWork',
    'commentaryType'
  ],
  data () {
    return {
      viewer: null,
      frameWidth: 0,
      frameHeight: 0,
      aspectRatio: 0,
      zoomRatio: 0,
      dialogOpen: false,
      isZoom: false,
      isZoomMin: true,
      isZoomMax: false,
      options: {
        inline: true,
        button: false,
        navbar: false,
        title: false,
        toolbar: false,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: false,
        scalable: false,
        transition: false, // これをtrueにすると滑らかになるが、初回にカクカクとなる
        fullscreen: false,
        keyboard: false,
        backdrop: false,
        zoomRatio: 0.3,
        maxZoomRatio: 1,
        minZoomRatio: 0.01, // closeの際にリセットしてるので注意
        zIndex: 99999,
        viewed: this.viewed,
        zoomed: this.zoomed,
        toggleOnDblclick: false
      },
      currentCommentaryType: null,
      isLoaded: false
    }
  },
  computed: {
    openDialog: {
      get () {
        return this.isOpen
      },
      set (value) {
        this.$emit('update:isOpen', value)
      }
    }
  },
  methods: {
    // 画像情報のみの場合true
    isImageOnly () {
      return !(this.winner && this.winner.isCommentWorks) && !this.isCommentaryExists()
    },
    loadComplete () {
      this.specialExhibitionWork.width = this.$refs.imageData.naturalWidth
      this.specialExhibitionWork.height = this.$refs.imageData.naturalHeight
      this.setImageSize()
      this.isLoaded = true
    },
    setImageSize () {
      // 基準値
      let standardWidth = 830
      let standardHeight = 840
      if (document.documentElement.clientWidth < 840) {
        standardWidth = Math.round(document.documentElement.clientWidth * 0.9) // 画面の横幅に対する比率
        standardHeight = Math.round(standardWidth * 1.012) // 縦は横の場合より1.012倍大きい
      }
      // 初期表示レシオの計算と表示位置の調整
      if (this.specialExhibitionWork.width > this.specialExhibitionWork.height) {
        // 横位置画像の場合の計算
        // 縦横比率の計算
        this.aspectRatio = (this.specialExhibitionWork.height / this.specialExhibitionWork.width)
        // 表示エリアの計算
        this.frameWidth = standardWidth // 横位置の基準値
        this.frameHeight = Math.round(this.frameWidth * this.aspectRatio)
        // 初期表示倍率の計算
        this.zoomRatio = this.frameWidth / this.$refs.imageData.naturalWidth
      } else {
        // 横位置画像の場合の計算
        // 縦横比率の計算
        this.aspectRatio = (this.specialExhibitionWork.width / this.specialExhibitionWork.height)
        // 表示エリアの計算
        this.frameHeight = standardHeight // 縦位置の基準値
        this.frameWidth = Math.round(this.frameHeight * this.aspectRatio)
        // 初期表示倍率の計算
        this.zoomRatio = this.frameHeight / this.$refs.imageData.naturalHeight
      }
      this.options.minZoomRatio = this.zoomRatio
    },
    inited (viewer) {
      this.viewer = viewer
      this.viewer.update() // 画像の状態を更新
    },
    viewed (event) {
      // 初期表示レシオと初期表示位置を調整
      this.viewer.zoomTo(this.zoomRatio)
      this.viewer.moveTo(0, 0)
      this.options.backdrop = false
    },
    reset () {
      this.viewer.zoomTo(this.zoomRatio)
      this.viewer.moveTo(0, 0)
      this.options.minZoomRatio = this.zoomRatio

      // イベント記録
      this.$ga.event('Image', 'zoomReset', 'Special', this.specialExhibitionWork.id)
    },
    clickImageHandler (event) {
      this.adjustImagePosition()
    },
    touchImageHandler (event) {
      this.adjustImagePosition()
    },
    mouseoutImageHandler (event) {
      this.adjustImagePosition()
    },
    adjustImagePosition () {
      const pos = this.getImagePosition()
      if (!pos) return
      // console.log('pos', pos)
      if (pos.x > 0 && (pos.x + pos.width) > this.frameWidth) pos.x = 0
      if (pos.y > 0 && (pos.y + pos.height) > this.frameHeight) pos.y = 0
      if (pos.x < 0 && (pos.x + pos.width) < this.frameWidth) pos.x = this.frameWidth - pos.width
      if (pos.y < 0 && (pos.y + pos.height) < this.frameHeight) pos.y = this.frameHeight - pos.height
      this.viewer.moveTo(pos.x, pos.y)
    },
    getImagePosition () {
      const viewImage = document.getElementsByClassName('viewer-move')
      let position = null
      if (viewImage && viewImage.length > 0) {
        position = {}
        const style = window.getComputedStyle(viewImage[0])
        position.x = Number(style.marginLeft.replace('px', ''))
        position.y = Number(style.marginTop.replace('px', ''))
        position.width = Number(style.width.replace('px', ''))
        position.height = Number(style.height.replace('px', ''))
      }
      return position
    },
    // ズームイベントハンドラ
    zoomed (event) {
      if (event.detail.ratio < this.zoomRatio) {
        this.viewer.zoomTo(this.zoomRatio) // 最低値を下回っていた場合、最低値に固定
        this.isZoomMin = true
      } else {
        this.isZoomMin = false
      }
      if (event.detail.ratio > 1) {
        this.viewer.zoomTo(1) // 最大値を上回っていた場合、最大値に固定
        this.isZoomMax = true
      } else {
        this.isZoomMax = false
      }
      // 表示位置調整
      this.adjustImagePosition()
    },
    zoomOut () {
      this.viewer.zoom(-0.2)

      // イベント記録
      this.$ga.event('Image', 'zoomOut', 'Special', this.specialExhibitionWork.id)
    },
    zoomIn () {
      this.viewer.zoom(0.2)

      // イベント記録
      this.$ga.event('Image', 'zoomIn', 'Special', this.specialExhibitionWork.id)
    },
    close () {
      this.openDialog = false
      this.isLoaded = false
      this.options.minZoomRatio = 0.01 // この値は操作中に変更されるので、closeの際にリセットしている

      // インスタンスの破棄
      if (this.viewer) {
        this.viewer.destroy()
      }

      // 一覧ページへURL書き換え
      const index = this.$route.path.indexOf('/images/')
      if (index >= 0) {
        const urlPath = this.$route.path.substring(0, index)
        this.$router.push(urlPath)
      }
    },
    changeComentaryTab (commentaryType) {
      this.currentCommentaryType = commentaryType
    },
    isCommentaryExists () {
      return (
        this.specialExhibitionWork && (
          this.specialExhibitionWork.comment ||
          this.specialExhibitionWork.youtubeUrl ||
          this.specialExhibitionWork.voice
        )
      )
    },
    isCommentExists () {
      return (
        this.specialExhibitionWork &&
        this.specialExhibitionWork.comment
      )
    },
    isCommentTabOn () {
      // コメントタブはコメントのみしか無い状況では非表示とする
      return (
        !(this.isCommentExists() || (!this.isMovieExists() && !this.isVoiceExists())) ||
        (this.isCommentExists() && (this.isMovieExists() || this.isVoiceExists()))
      )
    },
    isMovieExists () {
      return (
        this.specialExhibitionWork &&
        this.specialExhibitionWork.youtubeUrl
      )
    },
    isVoiceExists () {
      return (
        this.specialExhibitionWork &&
        this.specialExhibitionWork.voice
      )
    },
    convertYoutubeUrl (url) {
      return YoutubeUtil.getEmbedUrl(url)
    },
    windowResizeHandler () {
      this.setImageSize()
    },
    // 表示処理実行
    openImageViewer () {
      this.$refs.imageData.src = this.specialExhibitionWork.imageFile
      this.viewer = new Viewer(this.$refs.imageData, this.options) // 表示開始時にはインスタンスを新規生成

      if (this.$refs.imageData.naturalWidth !== 0 && this.$refs.imageData.naturalHeight !== 0) {
        // この段階で値が取れていれば、キャッシュに入っているので、loadedイベントを待たずに実行する
        this.loadComplete()
      }

      // 作品解説のデフォルトタブ設定
      this.currentCommentaryType = this.commentaryType
      if (!this.currentCommentaryType) {
        if (this.isCommentExists()) {
          this.currentCommentaryType = 'comment'
        } else if (this.isVoiceExists()) {
          this.currentCommentaryType = 'voice'
        } else if (this.isMovieExists()) {
          this.currentCommentaryType = 'movie'
        }
      }

      // イベント記録
      this.$ga.event('Image', 'open', 'Special', this.specialExhibitionWork.id)
    }
  },
  watch: {
    isOpen: function (value) {
      if (value) {
        this.openImageViewer() // 表示
      }
    },
    '$route.path': function (val, oldVal) {
      // '/images/'が含まれていたURLから '/images/'が含まれないURLに変わった場合は、画面が遷移したと判定しclose処理
      const index = val.indexOf('/images/')
      const oldIndex = oldVal.indexOf('/images/')
      if (oldIndex >= 0 && index < 0) {
        this.close()
      }
    }
  },
  created () {
  },
  mounted () {
    window.addEventListener('resize', this.windowResizeHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowResizeHandler)
  }
}
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  overflow-y: auto;
  display: none;
  opacity: 1;
  background-color: white;
  z-index: 9999;
  /* border: solid 1px red; */
}

.image {
  width: 640px;
  height: 640px;
  object-fit: contain;
  visibility: hidden;
}

.loadingBox {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 64px;
  max-width: 830px;
  width: 100%;
}
</style>
